import { CognitoJwtVerifier } from 'aws-jwt-verify';

export const CLIENT_ID = '6e0ibgv6ai30i309ae3lu484bn';
export const COGNITO_BASE_URL = 'https://stashsite.auth.us-west-2.amazoncognito.com';
export const COGNITO_USER_POOL_ID = 'us-west-2_9AdJV2OXN';

export interface TokenSet {
  access_token: string,
  refresh_token: string,
  id_token: string,
  token_type: string,
  expires_in: number,
}

export const verifyAndUnpack = async (token: string, type: 'id' | 'access') => {
  const verifier = CognitoJwtVerifier.create({
    userPoolId: COGNITO_USER_POOL_ID,
    tokenUse: type,
    clientId: CLIENT_ID,
  });

  try {
    const payload = await verifier.verify(
      token,
    );

    return payload;
  } catch (err) {
    console.error('Token not valid!', err);
  }
};